import classNames from 'clsx';
import { sanitize } from 'dompurify';
import React, { memo, useCallback } from 'react';
import { ENABLE_FULL_RESPONSIVE } from 'reactApp/appHelpers/configHelpers';
import { CancelIconOutline } from 'reactApp/ui/VKUIIcons';

import styles from './Snackbar.css';

export enum ESnackbarTheme {
    REGULAR = 'regular',
    COMPACT = 'compact',
}

interface IProps {
    onClose?(): void;
    icon?: any;
    stretched?: boolean;
    title?: string;
    text?: string;
    closable?: boolean;
    buttonText?: string;
    onButtonClick?(): void;
    visible?: boolean;
    theme?: ESnackbarTheme;
    bigSnackbar?: boolean;
}

export const Snackbar = memo(function Snackbar(props: IProps) {
    const {
        title,
        text,
        icon,
        closable,
        buttonText,
        onClose,
        onButtonClick,
        visible = true,
        theme = ESnackbarTheme.COMPACT,
        bigSnackbar,
    } = props;

    const onClick = useCallback(() => {
        onButtonClick?.();
        onClose?.();
    }, [onButtonClick, onClose]);

    return (
        <div
            className={classNames(styles.root, styles[`root_theme_${theme}`], {
                [styles.root_visible]: Boolean(visible),
                [styles.responsive]: ENABLE_FULL_RESPONSIVE,
            })}
        >
            {icon && <div className={styles.icon}>{icon}</div>}

            <div className={styles.container}>
                {title && <div className={styles.title}>{title}</div>}
                {text && (
                    <div
                        className={classNames(styles.text, bigSnackbar ? styles.textBig : styles.textSmall)}
                        dangerouslySetInnerHTML={{ __html: sanitize(text, { ADD_ATTR: ['target'] }) }}
                    />
                )}

                {buttonText && (
                    <div className={styles.buttonLink} onClick={onClick}>
                        {buttonText}
                    </div>
                )}
            </div>

            {closable && (
                <div className={styles.close} onClick={onClose}>
                    <CancelIconOutline className={styles.closeIcon} />
                </div>
            )}
        </div>
    );
});
